import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { CAPI_ENDPOINT } from './site';

// The pixel is initialised in public/index.html. fbq is missing when a blocker
// strips it, which is exactly when the server event matters most.
const pixel = (...args) => {
  if (typeof window.fbq === 'function') window.fbq(...args);
};

// An SPA never reloads, so fire PageView per route rather than once on load.
export function usePageViews() {
  const { pathname } = useLocation();
  useEffect(() => pixel('track', 'PageView'), [pathname]);
}

// Sends the event twice — browser and server — sharing one id so Meta dedupes.
export function track(eventName, { userData, custom } = {}) {
  const eventId = newEventId();
  pixel('track', eventName, custom || {}, { eventID: eventId });

  if (!CAPI_ENDPOINT) return;
  fetch(CAPI_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      eventName,
      eventId,
      eventSourceUrl: window.location.href,
      userData: { ...userData, fbp: cookie('_fbp'), fbc: fbc() },
      custom,
    }),
    keepalive: true,
  }).catch(() => {});
}

const cookie = (name) =>
  (document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`)) || [])[2];

// _fbc only exists if the pixel loaded while the click id was still in the URL.
const fbc = () => {
  const existing = cookie('_fbc');
  if (existing) return existing;
  const id = new URLSearchParams(window.location.search).get('fbclid');
  return id ? `fb.1.${Date.now()}.${id}` : undefined;
};

// randomUUID needs a secure context and a recent browser, so keep a fallback.
const newEventId = () => {
  const c = typeof window !== 'undefined' ? window.crypto : undefined;
  return c && c.randomUUID
    ? c.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};
